export default {
  data() {
    return {
      visibleCoinsAgreePopup: false
    }
  },
  methods: {
    visibleCoinsAgreePopupHandle(bool) {
      this.visibleCoinsAgreePopup = bool
    }
  }
}
